import Block from './Block'
import store from '../store'

export default class Promotion extends Block {
  getElems() {
    super.getElems()

    this.select = this.el.querySelector('#filter-date')
    this.items = this.el.querySelectorAll('.b-promotion__promotion')
  }

  events() {
    super.events()

    this.select.addEventListener('change', this.onChange.bind(this, this.select))
  }

  onChange(el) {
    for (let i = 0; i < this.items.length; i++) this.items[i].classList.toggle('active', this.items[i].dataset.date === el.value)

    store.smoothScroll.update()
  }
}
